import { t } from 'i18next';

import { useNewStrategyContext } from './NewStrategyContext';
import { useUserStrategies } from '../../context/UserStrategies';

import { Icon } from '../UI';
import { Confirm } from './Confirm';
import { Button } from '../UI';
import { logger } from '../../helpers/logger';

export const Skip = () => {
  const { refetch: refetchStrategies } = useUserStrategies();

  const {
    newStrategy: { strategyId },
    closeConfirmModal,
    skipStrategy,
    deleteStrategy,
    loading,
  } = useNewStrategyContext();

  const onDelete = () => {
    logger.log('Skip:onDelete', strategyId);
    deleteStrategy!({ variables: { strategyId } }).then(() => {
      refetchStrategies!();
      closeConfirmModal!();
      skipStrategy!();
    });
  };

  return (
    <Confirm
      saveButtonMane={t('strategies.newStrategy.skip.saveDraft')}
      betweenButtons={
        <Button
          type="button"
          variant={'negative'}
          buttonClass={'mr-5'}
          loading={loading}
          onClick={onDelete}
        >
          {t('strategies.newStrategy.skip.deleteDraft')}
        </Button>
      }
      disabledButtons={loading}
      subtitle={t('strategies.newStrategy.skip.subtitle')}
      svg={<Icon svgName="question1" color="white" />}
      title={t('strategies.newStrategy.skip.title')}
      onCancel={closeConfirmModal!}
      onSave={skipStrategy!}
    />
  );
};
